<template>
  <div class="page" v-if="$conFun.clientWidth() > 768">
    <Nav isActive="5" :isIndex="isIndex" />
    <div style="position: relative">
      <img
        src="http://h5.shihua.com/static/yunxue/bmtdbg.png"
        style="width: 100%; min-height: 770px"
      />
      <div style="position: absolute; top: 100px; left: 0; width: 100%">
        <div class="pageWD">
          <div class="cter cff" style="padding-bottom: 30px">
            <div class="f36 pb10">报名通道</div>
            <div class="f20">Registration channel</div>
          </div>
          <div class="flex-sb">
            <div class="bmtdt_left">
              <div class="t1">数智营销 就选云学</div>
              <div class="t2">云学科技——带您共享万亿蓝海市场</div>
              <div class="t3">
                公域流量已然饱和，而私域还拥有巨大的潜力，云学科技-数智营销教育的开创者，通过渠道获客、营销自动化、私域流量运营、智慧分销、私域直播等课程带您领跑时代，搭载咨询陪跑，定向孵化，增值代运营带您共享万亿蓝海市场。
              </div>
              <div class="t4">数智时代已经开启，</div>
              <div class="t5">抓住红利期就现在！</div>
            </div>
            <div class="bform">
              <div>
                <input
                  type="text"
                  placeholder="您的姓名"
                  style="width: 100%"
                  v-model="page.xm"
                />
              </div>
              <div>
                <input
                  type="text"
                  placeholder="公司名称"
                  style="width: 100%"
                  v-model="page.company"
                />
              </div>
              <div>
                <input
                  type="text"
                  placeholder="您的职务"
                  style="width: 100%"
                  v-model="page.position"
                />
              </div>
              <div>
                <input
                  type="text"
                  placeholder="手机号码"
                  style="width: 100%"
                  v-model="page.phone"
                />
              </div>
              <div>
                <input
                  type="text"
                  placeholder="所属行业"
                  style="width: 100%"
                  v-model="page.industry"
                />
              </div>
              <div>
                <textarea
                  placeholder="需求描述"
                  style="width: 100%"
                  v-model="page.desp"
                />
              </div>
              <div>
                <input
                  type="button"
                  @click="subMe"
                  value="提交"
                  :disabled="isDis"
                  style="
                    border: 0;
                    width: 100%;
                    background: #4db4e4;
                    color: #fff;
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pageWD p100">
        <img
          src="http://h5.shihua.com/static/yunxue/yxkc.png?v=1"
          style="width: 160px"
        />
        <div class="ctabs">
          <div class="in">
            <div class="current" style="text-align: right; margin-right: 50px">
              线上课程
            </div>
            <!-- <div>线下课程</div> -->
          </div>
        </div>
        <div class="flex-sb">
          <div v-for="(item, index) in courselist" class="kclist" :key="index">
            <img :src="item.imgUrl" style="width: 289px; height: 153px" />
            <div class="f16">{{ item.name }}</div>
            <div class="see f12 c6" @click="showDown = true">查看详情>></div>
          </div>
        </div>
      </div>
      <div class="pageWD">
        <img
          src="http://h5.shihua.com/static/yunxue/zjls.png"
          style="width: 160px"
        />
        <div class="ctabs">
          <div class="in">
            <div class="current" style="text-align: right; margin-right: 50px">
              线上师资
            </div>
            <!-- <div>线下师资</div> -->
          </div>
        </div>
      </div>
      <swiper :swiperList="swiperList" v-if="swiperList" />
      <div class="pageWD pb100">
        <img
          src="http://h5.shihua.com/static/yunxue/czfw.png"
          style="width: 160px"
        />
        <div class="flex-sb" style="margin: 60px 40px">
          <div v-for="(item, index) in fwlist" class="czfw" :key="index">
            <div style="margin-top: 60px"><img :src="item.icon" /></div>
            <div class="f20 dark" style="font-weight: 700">{{ item.text }}</div>
          </div>
        </div>
        <div class="zixun" @click="tapMeMO">立刻咨询</div>
      </div>
    </div>
    <showBox v-if="showDown" @hideMe="showDown = false" />
    <Fotter />
  </div>
  <div v-else>
    <Nav />
    <div  class="mbpage">
     <div >
      <div style="position:relative">
      <img
        src="http://h5.shihua.com/static/yunxue/bmtdbg.png"
        style="width: 100%;height:400px "
      />
      <div style="position:absolute;top:20px;left:0px;right:0px">
          <div class="cter cff" style="padding-bottom: 20px">
            <div class="f24 pb10">报名通道</div>
            <div class="f14">Registration channel</div>
          </div>
           <div class="bmtdt_left" style="padding-right:0">
              <div class="t1" style="font-size:18px">数智营销 就选云学</div>
              <div class="t2"  style="font-size:14px">云学科技——带您共享万亿蓝海市场</div>
              <div class="t3" style="font-size:14px;margin:20px 0;line-height:30px;padding:0 10px">
                公域流量已然饱和，而私域还拥有巨大的潜力，云学科技-数智营销教育的开创者，通过渠道获客、营销自动化、私域流量运营、智慧分销、私域直播等课程带您领跑时代，搭载咨询陪跑，定向孵化，增值代运营带您共享万亿蓝海市场。
              </div>
              <div class="t4" style="font-size:14px">数智时代已经开启，</div>
              <div class="t5" style="font-size:14px">抓住红利期就现在！</div>
            </div>
        </div>
      </div>
        <div style="background:#fff;">
            <div class="bform" style="padding:20px;width:auto">
              <div>
                <input
                  type="text"
                  placeholder="您的姓名"
                  style="width: 100%;background:#eee"
                  v-model="page.xm"
                />
              </div>
              <div>
                <input
                  type="text"
                  placeholder="公司名称"
                  style="width: 100%;background:#eee"
                  v-model="page.company"
                />
              </div>
              <div>
                <input
                  type="text"
                  placeholder="您的职务"
                  style="width: 100%;background:#eee"
                  v-model="page.position"
                />
              </div>
              <div>
                <input
                  type="text"
                  placeholder="手机号码"
                  style="width: 100%;background:#eee"
                  v-model="page.phone"
                />
              </div>
              <div>
                <input
                  type="text"
                  placeholder="所属行业"
                  style="width: 100%;background:#eee"
                  v-model="page.industry"
                />
              </div>
              <div>
                <textarea
                  placeholder="需求描述"
                  style="width: 100%;background:#eee"
                  v-model="page.desp"
                />
              </div>
              <div>
                <input
                  type="button"
                  @click="subMe"
                  value="提交"
                  :disabled="isDis"
                  style="
                    border: 0;
                    width: 100%;
                    background: #4db4e4;
                    color: #fff;
                  "
                />
              </div>
            </div>
        </div> 

      <div>
        <img
          src="http://h5.shihua.com/static/yunxue/yxkc.png?v=1"
          style="width: 130px;margin:0 0 20px 20px"
        />
        <!-- <div class="ctabs" style="margin:10px 0">
          <div class="in">
            <div class="current" style="text-align: right;font-size:14px">
              线上课程
            </div>
          
          </div>
        </div> -->
        <div style="padding:0 20px">
          <div v-for="(item, index) in courselist" class="kclist" :key="index" style="width:100%">
            <img :src="item.imgUrl" style="width: 100%" />
            <div class="f16" style="height:auto">{{ item.name }}</div>
            <div class="see f12 c6" @click="showDown = true">查看详情>></div>
          </div>
        </div>
      </div>
      <div>
        <img
          src="http://h5.shihua.com/static/yunxue/zjls.png"
           style="width: 130px;margin:0 0 20px 20px"
        />
        <!-- <div class="ctabs">
          <div class="in">
            <div class="current" style="text-align: right; margin-right: 50px">
              线上师资
            </div>
          </div>
        </div> -->
      </div>
      <swiper :swiperList="swiperList" v-if="swiperList" />
      <div class=" pb100">
        <img
          src="http://h5.shihua.com/static/yunxue/czfw.png"
          style="width: 130px;margin:0 0 20px 20px"
        />
        <div class="flex-sb" style="margin: 20px">
          <div v-for="(item, index) in fwlist" class="czfw" :key="index">
            <div style="margin-top: 60px"><img :src="item.icon" /></div>
            <div class="f20 dark" style="font-weight: 700">{{ item.text }}</div>
          </div>
        </div>
        <div class="zixun" @click="tapMeMO">立刻咨询</div>
      </div>
    </div>
    </div>
    <showBox v-if="showDown" @hideMe="showDown = false" />
    <Fotter />
  </div>  
</template>
<script>
import { addAdvisePost } from "@/api/api";
import Swiper from "swiper";
import "swiper/css/swiper.css";
import Nav from "@/components/Nav.vue";
import Fotter from "@/components/Fotter.vue";
import swiper from "@/components/swiper.vue";
import showBox from "@/components/showBox.vue";
export default {
  name: "bmtd",
  components: { Nav, Fotter, swiper, showBox },
  data() {
    return {
      isDis: false,
      page: {
        xm: "",
        company: "",
        position: "",
        phone: "",
        industry: "",
        desp: "",
      },
      formdata: {
        memberId: 0,
        name: "",
        phone: "",
        adviceContent: "",
        adviceType: 5,
      },
      showDown: false,
      swiperList: [
        {
          bigpic: "http://h5.shihua.com/static/yunxue/dd.png?v=1",
          title: "导师",
          subtitle: "云学科技导师",
          text: "云学科技导师云学科技导师云学科技导师云学科技导师云学科技导师云学科技导师云学科技导师云学科技导",
          litpic: "http://h5.shihua.com/static/yunxue/dd.png",
        },
      ],
      courselist: [
        {
          name: "品牌与营销：从入门到精通",
          imgUrl: "http://h5.shihua.com/static/yunxue/c1.png",
          img: "",
        },
        {
          name: "怎么做社群微营销，才能激起千万量级传播？",
          imgUrl: "http://h5.shihua.com/static/yunxue/c2.png",
          img: "",
        },
        {
          name: "大神教你玩转微信营销，快速获取1000万粉丝",
          imgUrl: "http://h5.shihua.com/static/yunxue/c3.png",
          img: "",
        },
        {
          name: "简单9招，玩转社会化媒体营销",
          imgUrl: "http://h5.shihua.com/static/yunxue/c4.png",
          img: "",
        },
      ],
      fwlist: [
        {
          num: "http://h5.shihua.com/static/yunxue/01.png",
          icon: "http://h5.shihua.com/static/yunxue/011.png",
          text: "转型陪跑",
        },
        {
          num: "http://h5.shihua.com/static/yunxue/02.png",
          icon: "http://h5.shihua.com/static/yunxue/022.png",
          text: "定向孵化",
        },
        {
          num: "http://h5.shihua.com/static/yunxue/03.png",
          icon: "http://h5.shihua.com/static/yunxue/033.png",
          text: "增值代运营",
        },
      ],
      isIndex: 1,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    tapMeMO(){       
      this.$router.push({path: '/onlineing' })                    
    },
    subMe() {
      var that = this;
      if (this.page.xm == "") {
        this.$message({
          message: "请输入姓名！",
          offset: 300,
          type: "warning",
        });
        return;
      }
      if (this.page.company == "") {
        this.$message({
          message: "请输入公司名称！",
          offset: 300,
          type: "warning",
        });
        return;
      }
      if (this.page.phone.length != "11") {
        this.$message({
          message: "请输入正确手机号码！",
          offset: 300,
          type: "warning",
        });
        return;
      }
      if ((this.page.phone + "").substr(0, 1) != "1") {
        this.$message({
          message: "请输入正确手机号码！",
          offset: 300,
          type: "warning",
        });
        return;
      }
      if (this.page.position == "") {
        this.$message({
          message: "请输入职位！",
          offset: 300,
          type: "warning",
        });
        return;
      }
      if (this.page.industry == "") {
        this.$message({
          message: "请输入行业！",
          offset: 300,
          type: "warning",
        });
        return;
      }
      var url =
        "https://qiyeapi.yunxuekeji.cn/yunxue_co_api/systemConfig/addAdvise";
      this.formdata.name =
      this.page.xm + "&" + this.page.company + "&" + this.page.position;
      this.formdata.phone = this.page.phone;
      this.formdata.adviceContent = this.page.desp
      this.isDis = true;
      this.$axios({
        url: url, //请求地址
        method: "POST", //请求方法
        responseType: "json", //返回值类型
        params: this.formdata,
      })
        .then((res) => {
          that.$message({
            message: "提交成功，客服会尽快联系您！",
            offset: 300,
            type: "success",
          });
          that.isDis = false;
          that.page= {
            xm: "",
            company: "",
            position: "",
            phone: "",
            industry: "",
            desp: "",
          }
        })
        .catch((error) => {
          that.isDis = false;
          console.log(error); //请求失败
        });

      // addAdvisePost(data).then((res) => {
      //   console.log(res);
      //   this.$message({
      //     message: "提交成功，客服会尽快联系您！",
      //     offset: 300,
      //     type: "success",
      //   });
      //   this.isDis = false;
      // });
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 60) {
        this.isIndex = 2;
      } else {
        this.isIndex = 1;
      }
    },
  },
};
</script>
<style scoped>
.bmtdt_left {
  flex: 1;
  padding-right: 95px;
}
.bmtdt_left .t1 {
  font-size: 34px;
  padding-left: 10px;
  font-weight: 700;
  text-align: left;
  color: #ffffff;
}
.bmtdt_left .t2 {
  font-size: 30px;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
  background: url("http://h5.shihua.com/static/yunxue/bbg.png") left bottom
    no-repeat;
  padding-left: 10px;
  margin: 10px 0;
}
.bmtdt_left .t3 {
  margin: 40px 0;
  font-size: 20px;
  padding-left: 10px;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
  line-height: 40px;
}
.bmtdt_left .t4 {
  font-size: 34px;
  padding-left: 10px;
  font-weight: 800;
  text-align: left;
  color: #34ade5;
}
.bmtdt_left .t5 {
  font-size: 34px;

  font-weight: 800;
  text-align: right;
  color: #34ade5;
  margin-top: 10px;
}

.czfw {
  width: 360px;
  height: 262px;
  background: url("http://h5.shihua.com/static/yunxue/zcfwbg.png") no-repeat;
  text-align: center;
}
.zixun {
  width: 305px;
  height: 80px;
  background: url("http://h5.shihua.com/static/yunxue/btn.png") no-repeat;
  margin: 0 auto;
  font-size: 30px;
  text-align: center;
  color: #fff;
  line-height: 80px;
}
.ctabs {
  height: 50px;
  margin: 50px auto;

  border-bottom: 1px solid #dcdcdc;
}
.ctabs .in {
  width: 300px;
  display: flex;
  text-align: center;
  margin: 0 auto;
}
.ctabs .in div {
  width: 150px;
  font-size: 24px;
  color: #333333;
}
.ctabs .in div.current {
  color: #25a2dd;
  font-size: 28px;
  position: relative;
  top: -4px;
}
.ctabs .in div.current:after {
  content: "";
  position: absolute;
  left:55px;
  bottom: -17px;
  height: 2px;
  background: #25a2dd;
  width: 80px;
}

.turnpic {
  border: 1px solid red;
  height: 184px;
  width: 1200px;
  margin: 0 auto;
  position: absolute;
  bottom: 20px;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/bmtd/index.vue